import Analytics from 'utils/analytics';

interface AppState {
  analytics: Analytics | null;
}

export const appState: AppState = {
  analytics: null,
};
